<div class="canvas-container">



  <section class="canvas-titlebar">
    <div class="titlebar-left">
      <h3>Data Model</h3>
      <p>
        Generate and customize how your data entities are visualized and interacted with in the AI assistant and
        database entity viewers
      </p>
    </div>
    <div class="titlebar-right">
<!--
      <button nz-button
              nz-tooltip
              [nzTooltipTitle]="'Test Button'"
              nzType="default"
              nzSize="small"
              class="canvas-title-button"
              (click)="onCanvasButtonClicked($event)">
        <i class="fa-regular fa-star"></i>&nbsp;Test
      </button>
      -->
    </div>

  </section>

  <div class="canvas-content-container">
    <!-- Show loading state for creation and updates -->
    <div *ngIf="isLoading || isUpdating" class="loading-state">
      <div class="loading-content">
        <i class="fa-solid fa-spinner fa-spin"></i>
        <h4>{{isLoading ? loadingMessage : updatingMessage}}</h4>
        <p>{{isLoading ? 'Please wait while we create your data model...' : 'Please wait while we update your data model...'}}</p>
      </div>
    </div>

    <div *ngIf="!selectedProjectModel && !isLoading && !isUpdating" class="no-model-selected">
      <div class="no-model-content">
        <i class="fa-regular fa-database-circle-plus"></i>
        <h4>Ready to Create Your Data Model</h4>
        <p>Use AI to generate a custom data model by describing your requirements in the chat. The AI will create a structured data model with appropriate fields and types for your needs.</p>
      </div>
    </div>


     <div *ngIf="selectedProjectModel && !isLoading && !isUpdating" class="model-details">
       <rappider-data-field-list [projectModelId]="selectedProjectModel.id" [isCanvasMode]="true"></rappider-data-field-list>
     </div>
  </div>


</div>
